import { on } from './utils';

EventTarget.prototype.on = function (name, func, options) {
  on(name, func, options, this);
};
